import React from "react";
import "react-toastify/dist/ReactToastify.css";

import AppRoutes from "./AppRoutes";
import { Layout } from "./components/Layout";
import { useMount } from "react-use";
import '@fontsource/roboto' // defaults as font-weight 400
import '@fontsource/roboto/500.css'
import '@deque/cauldron-styles'
import '@deque/cauldron-react/lib/cauldron.css'

export const App = () => {

	useMount(() => {
	});

	return (
			<Layout>
				<AppRoutes />
			</Layout> 
);

};
